import {
  LayoutDashboard, Bot, Building2, CreditCard, Banknote, FolderOpen,
  FileSignature, GraduationCap, TrendingUp, Users, LibraryBig,
  Bell, User, Settings, Receipt, ShieldCheck, ScrollText, Download, Shield, UsersRound, Gift, Lightbulb, Wand2,
} from "lucide-react";

export const SECTIONS = [
  { key: "dashboard", label: "Dashboard", path: "/dashboard", icon: LayoutDashboard, group: "main" },
  { key: "ai", label: "AI Assistant", path: "/ai-assistant", icon: Bot, group: "main",
    desc: "Get instant expert business guidance", live: true },
  { key: "workflows", label: "Guided Workflows", path: "/workflows", icon: Wand2, group: "main",
    desc: "AI-guided, step-by-step business builders", live: true },
  { key: "formation", label: "Business Formation", path: "/formation", icon: Building2, group: "build",
    desc: "Launch your entity step by step", live: true },
  { key: "credit", label: "Business Credit", path: "/credit", icon: CreditCard, group: "build",
    desc: "Build and monitor business credit", live: true },
  { key: "funding", label: "Funding Center", path: "/funding", icon: Banknote, group: "build",
    desc: "Discover loans, grants & investors", live: true },
  { key: "documents", label: "Document Library", path: "/documents", icon: FolderOpen, group: "manage",
    desc: "Store and organize key documents", live: true },
  { key: "contracts", label: "Contracts & Agreements", path: "/contracts", icon: FileSignature, group: "manage",
    desc: "Templates and signed agreements", live: true },
  { key: "compliance", label: "Compliance Center", path: "/compliance", icon: ScrollText, group: "manage",
    desc: "Stay legally compliant & in good standing", live: true },
  { key: "education", label: "Education & Training", path: "/education", icon: GraduationCap, group: "grow",
    desc: "Courses to grow your knowledge", live: true },
  { key: "progress", label: "Progress Tracker", path: "/progress", icon: TrendingUp, group: "grow",
    desc: "Track your journey milestones", live: true },
  { key: "portal", label: "Client Portal", path: "/portal", icon: Users, group: "grow",
    desc: "Collaborate with clients & team", live: true },
  { key: "team", label: "Team & Collaboration", path: "/team", icon: UsersRound, group: "grow",
    desc: "Invite team members & assign roles", live: true },
  { key: "referrals", label: "Refer & Earn", path: "/referrals", icon: Gift, group: "grow",
    desc: "Earn credits for referrals", live: true },
  { key: "feature-requests", label: "Feature Requests", path: "/feature-requests", icon: Lightbulb, group: "grow",
    desc: "Suggest & vote on features", live: true },
  { key: "resources", label: "Resource Center", path: "/resources", icon: LibraryBig, group: "grow",
    desc: "Guides, tools and templates", live: true },
  { key: "security", label: "Security Center", path: "/security", icon: Shield, group: "account",
    desc: "Protect your account & data", live: true },
  { key: "notifications", label: "Notifications", path: "/notifications", icon: Bell, group: "account",
    desc: "Stay up to date", live: true },
  { key: "billing", label: "Subscription & Billing", path: "/billing", icon: Receipt, group: "account",
    desc: "Manage your plan", live: true },
  { key: "profile", label: "Profile", path: "/profile", icon: User, group: "account",
    desc: "Your account details", live: true },
  { key: "settings", label: "Account Settings", path: "/settings", icon: Settings, group: "account",
    desc: "Preferences and security", live: true },
  { key: "data-export", label: "Data Export", path: "/data-export", icon: Download, group: "account",
    desc: "Download your data anytime", live: true },
];

export const ADMIN_SECTION = {
  key: "admin", label: "Admin Dashboard", path: "/admin", icon: ShieldCheck, group: "admin",
};

export const CARD_SECTIONS = SECTIONS.filter((s) => s.key !== "dashboard");
